import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementEmailTemplate.Delete.IRequest;
type Response = Api.Core.StatementEmailTemplate.Delete.IResponse;
type Headers = Api.Core.StatementEmailTemplate.Delete.IHeaders;
const url = '/api/Management/StatementEmailTemplate/:id';
export default async function statementEmailTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
